import { DEFAULT_PARSED_GLB_CACHE_VARIANT } from '@puppycad/cad-core'

/**
 * 共享 artifact key 组装器——由 `ImportedModelRequestRegistry` 的 in-flight dedup
 * 机制消费。`imported-model-loader.ts` 与 `assembly-loader.ts` 必须走同一个函数，
 * 否则并发抢占路径下两边各自构造的 key 不相等，跨 loader 的在途 promise 无法命中
 * 同一注册项，dedup 失效。
 *
 * 独立模块形式：`imported-model-loader.ts` 已经 import 了 `assembly-loader.ts`
 * （递归入口），所以 `assembly-loader.ts` 不能反向 import `imported-model-loader.ts`。
 * 本模块无任何 loader 依赖，被双方安全共享。
 */
export function buildParsedGlbArtifactKey(
  fileUuid: string,
  version: string,
  variant: string = DEFAULT_PARSED_GLB_CACHE_VARIANT,
): string {
  return `parsed-glb:${JSON.stringify([fileUuid, version, variant])}`
}
